export enum LoggerParams {
    id = 'id',
    functionName = 'functionName',
    functionParams = 'functionParams',
    objectValues = 'objectValues',
    serviceName = 'serviceName',
    description = 'description',
    exception = 'exception',
    returns = 'returns'
}